import { useState, useEffect, forwardRef } from "react";
import PropTypes from "prop-types";

import {
    RadioStyled,
    Content,
    Input,
    Circle,
    Fill,
    Text
} from "./Radio.styled";

const Radio = forwardRef(({ label, type, ...props }, ref) => {
    const [preloadClass, setPreloadClass] = useState("preload");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPreloadClass("");
        }
    }, []);

    return (
        <RadioStyled>
            <Input {...props} type={type} ref={ref} />
            <Content>
                <Circle>
                    <Fill className={preloadClass} />
                </Circle>
                <Text>{label}</Text>
            </Content>
        </RadioStyled>
    );
});

Radio.propTypes = {
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    value: PropTypes.any,
    type: PropTypes.string
};

Radio.defaultProps = {
    name: "radioButton",
    label: "radioButton",
    value: "true",
    type: "radio"
};

export default Radio;
